import { Component, Vue } from 'vue-property-decorator';

import InstallPromptService, { Outcome } from '@/services/install-prompt';
import { IS_ANDROID } from '@/helpers/browser';
import { Apps } from '@/constants/apps';

@Component({})
export default class InstallMixin extends Vue {
  get promptStore() {
    return InstallPromptService.getPromptStore();
  }

  get appInstalled() {
    const { installed } = this.promptStore;

    return installed !== null && installed;
  }

  get promptSupported() {
    return !!this.promptStore.deferred;
  }

  get promptOutcome() {
    return this.promptStore.outcome;
  }

  get promptDismissed() {
    return this.promptOutcome === Outcome.DISMISSED;
  }

  get canInstall() {
    if (this.$appName && Object.values(Apps).includes(this.$appName)) {
      return !this.appInstalled && this.promptSupported && !IS_ANDROID;
    }

    return false;
  }

  async promptInstall() {
    return InstallPromptService.promptInstall();
  }
}
